import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);
import { getChartDataRisk, getDatasourceAndDates } from '../../../api';
import { xlsxCustomExport } from '../utils/chartConfig';
import ReactHtmlParser from 'react-html-parser';
import { isFullscreen } from '../utils/Utils';
import SelectDataset from '../SelectDataset';

const IMG_URL = process.env.IMG_FULL_URL;

const euColor = 'blue';
const country1Color = '#5c5c5c';

class Chart extends Component {
	constructor(props) {
		super(props);

		let isDatasetFilterDisabled = true;

		if(this.props.selectedIndicator != 'sector'){
			isDatasetFilterDisabled = false;
		}else{
			isDatasetFilterDisabled = true;
		}
		
		const stateThis = this;
		this.state = {
			select: 'sector',
			dataset: this.props.typeChart != undefined ? this.props.typeChart : undefined,
			//dataset: undefined,
			isDatasetFilterDisabled,
			resetDataset: false,
			chartConfig: {
				title: {
					text:  this.props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+this.props.title+"</h2>",
					align: 'left',
                    widthAdjust: -50,
                    y:20,
                    style: {
                        zIndex: 1,
                        lineHeight:36
                    }
				},
				credits: {
                    enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: this.props.typeChart == 'ewcs' ? -270 : -130
					}
                },
				colors: this.props.colors,
				chart: {
					height: this.props.fullCountryReport == true ? 250 : 500,
					type: this.props.type,
					backgroundColor: '#F0F0F0',
					events: {
                        render: function() {
                            let chart = this;
                            stateThis.showEurofoundImage(chart);
                        }
                    }
				},
				exporting: {
					// enabled: true,
					enabled: this.props.exportingEnabled,
					scale: 1.5,
					sourceWidth: 1500,
					sourceHeight: 600,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
					menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Category', this.series, this.title.textStr);
                            }
                        }
                    }
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						}
					}
				},
				legend:{
					//reversed: this.props.legend
					verticalAlign: 'bottom',
					symbolRadius: 0,
					//layout: 'vertical',
					itemMarginTop:4,
					itemMarginBottom:4,
					//width: 300,
					itemStyle: {
						fontFamily: 'OpenSans',
						fontWeight: 'normal',
						fontSize:'12px',
						textOverflow: "ellipsis",
						width: 250
					}
				},
                // tooltip: {
				// 	headerFormat: '<b>Sector:</b>{point.x}<br/><b> Country</b> {series.name}<br/>',
				// 	pointFormat: '<b> Value </b> {point.y} %'
				// },
				tooltip: {					
					useHTML: true,
					style: {
						opacity: 1,
						zIndex: 100
					},
					formatter: function () {
						return '<ul class="tooltip-item">'+
						'<li><strong>Sector: </strong> ' + this.x + '</li>' +
						'<li><strong>Country: </strong> ' + this.series.name + '</li>' +
						'<li><strong> Value: </strong>' + this.y +'%</li>' +
						'</ul>';
					}
				},
				plotOptions: {
					series: {
						stacking: this.props.stacking

					},
					column: {
						stacking: this.props.stackingColumn,
						dataLabels: {
							enabled: this.props.showDataLabel === true ? true : false,
							overflow: 'none',
                            crop: false,
                            allowOverlap: true,
							style: {
								textOutline: 0,
								textShadow: false,
								fontFamily: 'OpenSans-Bold',
								fontSize:this.props.fullCountryReport ? '12px' : '14px'
							},
							formatter: function () {
								return '<span style="color: ' + this.point.color + '">' + this.y + '%</span>';
							}
						}
					},
					bar: {
						dataLabels: {
							enabled: this.props.showDataLabel === true ? true : false,
							formatter: function () {
								return '<span style="color: ' + this.point.color + '">' + this.y + '%</span>';
							}
						}
					}
				},
				xAxis: {
					lineWidth: 0,
					categories: [this.props.data?.categories],
					
					labels: {
						formatter: function () {
							if ([this.value] == 'EU28') {
								return "<span style='color:" + euColor + "'>" + [this.value] + "</span>"
							}
							else {
								return "<span style='color:" + country1Color + "'>" + [this.value] + "</span>"
							}
						},
						padding:this.props.fullCountryReport ? 20 : 15,
						style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',
							fontSize: this.props.fullCountryReport ? '10px' : '12px',
							textOverflow: 'none'
						}
					}
				},
				yAxis: {
					gridLineColor:'#FFF',
					gridLineWidth:2,
					reversed: this.props.reversed,
					max: this.props.yAxisMax,
					tickInterval: this.props.tick,
					title: {
						enabled: false
					},
					labels: {
						format: this.props.percentage === true ? '{value} %' : `{value} ${this.props.percentage}`,
						style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',
							fontSize: this.props.fullCountryReport ? '10px' : '12px',
							textOverflow: 'none'
						}
					}
				},
				series: [ ]
			}
		}
	}

	showEurofoundImage = (chart) => {
        let isEurofoundIndicator = this.props.typeChart == 'ewcs' ? true : false;
        if (!chart.customImage)
        {
            chart.customImage = chart.renderer.image(
                `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                chart.chartWidth - 130,
                chart.chartHeight - 37,
                130,
                37
            ).add();
            chart.customImage.attr({
				class:'osha-logo'
			});
        }
        else
        {
            chart.customImage.attr({
                x: chart.chartWidth - 130,
                y: chart.chartHeight - 37
            });
        }
        
        if(isEurofoundIndicator){
            if (!chart.customImageEurofound)
            {
                chart.customImageEurofound = chart.renderer.image(
                    `${IMG_URL}osh-barometer/img/eurofound-logo.png`,
                    chart.chartWidth - 270,
                    chart.chartHeight - 37,
                    130,
                    37
                ).add();
                chart.customImageEurofound.attr({
                class:'eurofound-logo'
            });
            }
            else
            {
                chart.customImageEurofound.attr({
                    x: chart.chartWidth - 270,
                    y: chart.chartHeight - 37
                });
            }
        }

        if (chart.fullscreen.isOpen) {
            chart.customImage.css({
                display: 'block'
            });
            if(isEurofoundIndicator){
                chart.customImageEurofound.css({
                    display: 'block'
                });
            }
            chart.container.className = 'highcharts-container full-screen';
        }
        else
        {
            chart.customImage.css({
                display: ''
            });
            if(isEurofoundIndicator){
                chart.customImageEurofound.css({
                    display: ''
                });
            }
            chart.container.className = 'highcharts-container';
        }
    }

	getLoadDataRisk = (chart, indicator, country1, country2, country3, sector, gender, age, skill, answer, dataset) => {
		let categories = [];
		let auxSeries = [];
		let series = [];
		let flashDataset = this.props.typeChart != 'flash' ? dataset : '27'

		// Load the texts for the credits in the image when maximising or exporting the chart
		this.getCredits(chart, flashDataset);
		this.setState({ ...this.state, chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, position: { x: this.props.typeChart == 'ewcs' ? -270 : -130 } } } });
		getChartDataRisk(chart, indicator, country1, country2, country3, 
			sector, gender, age, skill, answer, flashDataset)
			.then((res) => {
				res.resultset.forEach(element => {
					if (categories.indexOf(element.countryCode) == -1) {
						categories.push(element.split)
					}
					
					let split = element.country;
					if (!(split in auxSeries)) {
						auxSeries[split] = []
						
					}auxSeries[split].push(element.value)
					 
				});
					
			for (let serie in auxSeries) {
				series.push({ name: serie , data: auxSeries[serie] })
			}
			
			if(series.length == 3){
				this.setState({
					chartConfig: {...this.state.chartConfig, xAxis: {...this.state.chartConfig.xAxis, categories}, series, colors:['#f6a400','#529FA2','#003399']}
				})
			}
			else if (series.length == 4)
			{
				this.setState({
					chartConfig: {...this.state.chartConfig, xAxis: {...this.state.chartConfig.xAxis, categories}, series, colors:['#f6a400','#529FA2','#7b7b7d','#003399']}
				})
			}
			else if (series.length == 1 && (series[0].name == 'EU27_2020' || series[0].name == 'EU28'))
			{
				// Only EU will be painted
				this.setState({
					chartConfig: {...this.state.chartConfig, xAxis: {...this.state.chartConfig.xAxis, categories}, series, colors:['#003399']}
				})
			}
			else{
				this.setState({
					chartConfig: {...this.state.chartConfig, xAxis: {...this.state.chartConfig.xAxis, categories}, series}
				})
			}
		});
	}

	getCredits = (chart, dataset) => {
        getDatasourceAndDates(chart, dataset).then((res)=>{
            let text = res;
            this.setState({
                chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
            })
        })		
    }
	
	handleSelect = (e) => {
		const sector = e.target.value
		this.setState({
			select: e.target.value
		})
		if(/*sector != 'skill' && */sector != 'sector'){
			this.setState({
				isDatasetFilterDisabled: false
			})
		}else{
			this.setState({
				isDatasetFilterDisabled: true
			})
		}
		if(this.props.handleSector!=undefined){
			this.props.handleSector(sector);
		}
	}
	
	updateDimension = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;   

        if (width > 767) {
            const title = this.props.title;
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height},
                    }
                });
            } else {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: this.props.fullCountryReport == true? 250 : 450, type: 'column'},
                        title: {...this.state.chartConfig.title, text: this.props.fullCountryReport == true ? '' : this.props.reportTitle != undefined ? "<h2 class='title--card'>"+this.props.reportTitle+"</h2>" : `<h2 class='title--card'>${title}</h2>`}
                        // title: {...this.state.chartConfig.title, text: `<h2 class='title--card'>${title}</h2>`}
                    }
                });
            }
        }

        if (width < 768) {
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height},
                    }
                });
            } else {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: 785, type: 'bar'},
                        // title: {...this.state.chartConfig.title, text: this.props.reportTitle != undefined ? "<h2 class='title--card'>"+this.props.reportTitle+"</h2>" : <h2 class='title--card'>${tabTitle}</h2>}
                        title: {...this.state.chartConfig.title, text: this.props.fullCountryReport == true ? '' : `<h2 class='title--card'>${ this.props.title }</h2>`}
                    }
                });
            }
        }

        if (width < 400) {
            this.setState({
                chartConfig: {
                    ...this.state.chartConfig,
                    chart: {...this.state.chartConfig.chart, height: 1300},
                }
            });
        }        
	}

	componentDidMount() {
		if(this.props.showSelect){
			this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2,this.props.selectCountry3, this.props.sector, null, null, null, null, this.state.dataset);
		}else{
			if (this.props.selectedIndicator == 'sector'){
				this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.sector, null, null, null, this.props.answer, this.state.dataset);
			}
			if (this.props.selectedIndicator == 'gender'){
				this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, null, this.props.gender, null, null, this.props.answer, this.state.dataset);
			}
			if (this.props.selectedIndicator == 'age'){
				this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, null, null, this.props.age, null, this.props.answer, this.state.dataset);
			}
			if (this.props.selectedIndicator == 'skill'){
				this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, null, null, null, this.props.skill, null, this.state.dataset);
			}
		}

		this.updateDimension();
        window.addEventListener('resize', this.updateDimension);
	}

	componentDidUpdate(prevProps, prevState ) {
		if (!this.props.fullCountryReport)
		{
			if (prevState.select != this.state.select){
				if (this.state.select == 'sector'){
				  // The dataset cannot be Eurofound 2010
				  // Eurofound 2015 dataset ID is 10
				  const eurofound2015DatasetID = 10;
				  this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.sector, null, null, null, this.props.answer, eurofound2015DatasetID);
				  this.setState( { dataset: eurofound2015DatasetID, resetDataset: true } );
				}
				if (this.state.select == 'gender'){
				  this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, null, this.props.gender, null, null, this.props.answer, this.state.dataset);
				}
				if (this.state.select == 'age'){
				  this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, null, null,this.props.age, null, this.props.answer, this.state.dataset);
				}
				if (this.state.select == 'skill'){
					this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, null, null, null, this.props.skill, null, this.state.dataset);
				}
			}			
	
			if (this.state.select == 'sector'){
				if (prevProps.selectCountry1 != this.props.selectCountry1 || prevProps.selectCountry2 != this.props.selectCountry2 || prevProps.selectCountry3 != this.props.selectCountry3 || prevState.dataset != this.state.dataset) {
					this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2,this.props.selectCountry3, this.props.sector, null, null, null, this.props.answer, this.state.dataset)
				}
			} else if (this.state.select == 'gender'){
				if (prevProps.selectCountry1 != this.props.selectCountry1 || prevProps.selectCountry2 != this.props.selectCountry2 || prevProps.selectCountry3 != this.props.selectCountry3 || prevState.dataset != this.state.dataset) {
					this.getLoadDataRisk(this.props.chart,this.props.indicator,this.props.selectCountry1,this.props.selectCountry2,this.props.selectCountry3, null,this.props.gender, null, null, this.props.answer, this.state.dataset)
				}
			} else if (this.state.select == 'age'){
				if (prevProps.selectCountry1 != this.props.selectCountry1 || prevProps.selectCountry2 != this.props.selectCountry2 || prevProps.selectCountry3 != this.props.selectCountry3 || prevState.dataset != this.state.dataset) {
					this.getLoadDataRisk(this.props.chart,this.props.indicator,this.props.selectCountry1,this.props.selectCountry2,this.props.selectCountry3, null,null,this.props.age, null, this.props.answer, this.state.dataset)
				}
			} else if (this.state.select == 'skill'){
				if (prevProps.selectCountry1 != this.props.selectCountry1 || prevProps.selectCountry2 != this.props.selectCountry2 || prevProps.selectCountry3 != this.props.selectCountry3 || prevState.dataset != this.state.dataset) {
					this.getLoadDataRisk(this.props.chart,this.props.indicator,this.props.selectCountry1,this.props.selectCountry2,this.props.selectCountry3, null,null,null,this.props.skill, null, this.state.dataset)
				}
			}
		}
		else
		{
			if (this.props.selectCountry1 != prevProps.selectCountry1)
			{
				if (this.props.selectedIndicator == 'sector'){
					this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, this.props.sector, null, null, null, this.props.answer, this.state.dataset)	
				}
				if (this.props.selectedIndicator == 'gender'){
					this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, null, this.props.gender, null, null, this.props.answer, this.state.dataset);
				}
				if (this.props.selectedIndicator == 'age'){
					this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, null, null,this.props.age, null, this.props.answer, this.state.dataset);
				}
				if (this.props.selectedIndicator == 'skill'){
					this.getLoadDataRisk(this.props.chart, this.props.indicator, this.props.selectCountry1, this.props.selectCountry2, this.props.selectCountry3, null, null, null, this.props.skill, null, this.state.dataset);
				}
			}
		}
	}

	componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimension);
    }

	/* BAD22-4 Select years back in time */
	handleDatasetChange = (dataset, indicator) => {
		this.setState({
			dataset: dataset,
			resetDataset: false
		})
	}

	render() {
		let selectDiv;
		let selectDatasetDiv;

		if(this.props.showSelect){
			selectDiv = (
				<div className="select-filter-chart" >
					<select onChange={this.handleSelect} className="ng-pristine ng-untouched ng-valid" name="" id="">
						<option className="ng-binding" value="sector">{ReactHtmlParser(this.props.literals.L20652)}</option>
						<option className="ng-binding" value="gender">{ReactHtmlParser(this.props.literals.L20649)}</option>
						<option className="ng-binding" value="age">{ReactHtmlParser(this.props.literals.L20650)}</option>
						<option className="ng-binding" value="skill">{ReactHtmlParser(this.props.literals.L20100)}</option>
					</select>
				</div>
			)

			/* BAD22-4 Select years back in time */
			selectDatasetDiv = (
				<div className='select--dataset--chart'>
					<SelectDataset 
						chart={this.props.chart}
						indicator={this.props.indicator}
						handleDatasetChange={(e) => this.handleDatasetChange(e, this.props.indicator)}
						handleDefaultDataset={this.handleDefaultDataset}
						isDisabled={this.state.isDatasetFilterDisabled}
						reset={this.state.resetDataset}
					/>
				</div>
			)
		}

		// There is a known bug with the Full Screen option, when exiting the chart takes the full height and width of the screen
		// In order to fix it, add a className to the Highcharts element in the containerProps and set a fixed height (in pixels) in the CSS
		// Do not set the height of the chart in the options. If so, when going full screen, it will only take the height configured in the options
		return (
			<div className='chart-container'>
				<div className='chart--filters--block'>
					{selectDiv}
					{selectDatasetDiv}
				</div>
				<HighchartsReact
					highcharts={Highcharts}
					options={this.state.chartConfig}
					containerProps={{ className: 'chartContainer' }}
				/>
			
			</div>
		)
	}
}

export default Chart;